import logo from '../media/logo.svg'
import logowhite from '../media/logo-white.png';
import aboriginalFlag from '../media/aboriginalFlag.svg'
import torresFlag from '../media/torresFlag.svg'

import useSettings from "./settings/useSettings.js";
import { useDarkMode } from './support/DarkModeContext';
import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import useSiteImprove from './support/useSiteImprove.js';

import EmailIcon from '@material-ui/icons/MailOutline';
import PhoneAndroid from '@material-ui/icons/PhoneAndroid';

const useStyles = makeStyles((theme) => ({
    root: {
        fontSize: '0.9em',
        borderTopStyle: 'solid',
        borderTopColor: '#eee',
        borderTopWidth: '1px',
        paddingTop: '2em',
        "@media print": {
            display: "none !important"
        }
    },
    top: {
        marginBottom: '2em'
    },
    bottom: {
        paddingBottom: '15px'
    },
    subhead: {
        fontSize: '1em',
        marginBottom: '0.8em',
        fontWeight: "bold !important"
    },
    logo: {
        height: '95px'
    },
    flag: {
        width: '50px',
        height: 'auto',
        display: 'inline-block',
        margin: '2px'
    },
    flag2: {
        width: '45px',
        height: 'auto',
        display: 'inline-block',
        margin: '2px'
    },
    statement: {
        width: '40%'
    },
    copy: {
        textAlign: 'right',
        width: '50%'
    },
    b1: {
        display: "flex",
        justifyContent: "space-between"
    },
    icon: {
        display: 'flex',
        flexDirection: 'row',
        maxWidth: '250px',
        '& svg': { width: "1.3em", height: "1.3em", marginRight: "0.5em" },
        '& div': {flex: 1}
    }
}));
export default function Footer(props) {
    //const settings = useSettings();
    const classes = useStyles();
    const { isDarkMode, setIsDarkMode } = useDarkMode();
    useSiteImprove();
    /*const mailto = useRef();
    const [email, setEmail] = useState(settings.get("Email") || "ltc-central@uow.edu.au");

    useEffect(() => {
        setEmail(settings.get("Email"));
        mailto.current.setAttribute("href", "mailto:" + settings.get("Email"));
    }, [settings]);*/
    return (
        <Box className={classes.root}>
            <Box className={classes.top + " " + classes.b1}>
                <Box>
                    {/*<Typography className={classes.subhead}>Contact Learning, Teaching &amp; Curriculum</Typography>*/}
                    {/*<div className={classes.icon} style={{ alignItems: 'center', marginBottom: "1em" }}>*/}
                    {/*    <EmailIcon />*/}
                    {/*    <div><a href="mailto:ltc-central@uow.edu.au">ltc-central@uow.edu.au</a></div>*/}
                    {/*</div>*/}
                    {/*<div className={classes.icon}>*/}
                    {/*    <PhoneAndroid />*/}
                    {/*    <div><b>(02) 4221 4004</b><br />*/}
                    {/*        8:30 AM to 5:00 PM Monday to Friday (AEDT)</div>*/}
                    {/*</div>*/}
                </Box>
                <Box>
                    <img src={isDarkMode ? logowhite: logo} alt="UOW logo" className={classes.logo} />
                </Box>
            </Box>
            <Box className={classes.b1}>
                <Box>
                    <img src={aboriginalFlag} alt="Aboriginal flag" className={classes.flag} />
                    <img src={torresFlag} alt="Torres Strait Islander flag" className={classes.flag2} />
                </Box>
            </Box>
            <Box className={classes.bottom + " " + classes.b1}>
                <Box className={classes.statement}>
                        On the lands that we study, we walk, and we live, we acknowledge and respect the traditional custodians and cultural knowledge holders of these lands.
                </Box>
                <Box className={classes.copy}>
                    <strong>Copyright © {new Date().getFullYear()} University of Wollongong</strong>
                    <br />CRICOS Provider No: 00102E | <a href="https://www.uow.edu.au/privacy/">Privacy &amp; cookie usage</a> | <a href="https://www.uow.edu.au/about/governance/copyright-and-disclaimer/">Copyright &amp; disclaimer</a>
                </Box>
            </Box>
        </Box>
    );
}
